import React from 'react';
import { PropTypes } from 'prop-types';
import styled from 'styled-components';

import { propertyOptions } from '@general/helpers/property.helpers';
import CheckboxGroup from '@atoms/CheckboxGroup';
import { TenantsSpacesStrings, toCheckboxOrRadioOptions } from '@general/helpers/SavedSearchesQuestionStrings';

const SectionContainer = styled.div`
    margin-bottom: 40px;
`;

export const Space = ({ kind, values }) => (
    <div>
        <SectionContainer>
            <CheckboxGroup
                label="Preferred Purpose of Space"
                name={`${kind}[purpose]`}
                value={values[kind]?.purpose}
                instructions="Check all that apply."
                options={toCheckboxOrRadioOptions(TenantsSpacesStrings.purpose)}
                required
            />
        </SectionContainer>

        <SectionContainer>
            <CheckboxGroup
                label="Population Density"
                name={`${kind}[density]`}
                value={values[kind].density}
                instructions="Check all that apply."
                options={Object.keys(propertyOptions.populationDensity).map(densityKey => {
                    const density = propertyOptions.populationDensity[densityKey];
                    return {
                        value: densityKey,
                        label: density.label,
                        tooltip: density.tooltip || null,
                    };
                })}
                required
            />
        </SectionContainer>

        <SectionContainer>
            <CheckboxGroup
                label="Type of Center(s)"
                name={`${kind}[typeOfCenter]`}
                value={values[kind].typeOfCenter}
                instructions="Check all that apply."
                options={toCheckboxOrRadioOptions(TenantsSpacesStrings.typeOfCenter)}
                required
            />
        </SectionContainer>

        <SectionContainer>
            <CheckboxGroup
                label="Type of Facility"
                name={`${kind}[typeOfFacility]`}
                value={values[kind].typeOfFacility}
                instructions="Check all that apply."
                options={toCheckboxOrRadioOptions(TenantsSpacesStrings.typeOfFacility)}
                required
            />
        </SectionContainer>

        <CheckboxGroup
            label="Size of Space"
            name={`${kind}[size]`}
            value={values[kind].size}
            instructions="Check all that apply."
            options={toCheckboxOrRadioOptions(TenantsSpacesStrings.size)}
            required
        />
    </div>
);

Space.propTypes = {
    kind: PropTypes.string,
    values: PropTypes.object,
};
